import { render, staticRenderFns } from "./STable.vue?vue&type=template&id=234594fe&scoped=true"
import script from "./STable.vue?vue&type=script&lang=js"
export * from "./STable.vue?vue&type=script&lang=js"
import style0 from "./STable.vue?vue&type=style&index=0&id=234594fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "234594fe",
  null
  
)

export default component.exports